<template>
  <div class="progress">
    <div class="bar bg-gradient-green-blue" :style="{ width: progress * 100 + '%'}"></div>
    
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: ["progress"]
}
</script>

<style scoped>
  .progress {
    width: 100%;
    margin-left: -2rem;
    margin-right: -2rem;
    margin-top: -1rem;
    margin-bottom: 1.5rem;
  }
  .bar {
    height: 5px;
    transition: width 0.4s ease-in;
  }
</style>